import { createFormHookContexts } from "@tanstack/react-form";

/**
 * Shared form/field contexts for TanStack Form.
 * Used by the form hook and by field/form components to access state.
 *
 * This is separated from form-hook.ts to avoid circular imports:
 * field components import from here, and form-hook imports both
 * these contexts and the field components.
 */
export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();
